import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSpacebar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconSpacebar"><Path d="M2 17.5V13.5C2 13.2239 2.22386 13 2.5 13C2.77614 13 3 13.2239 3 13.5V17.5C3 18.3284 3.67157 19 4.5 19H19.5C20.3284 19 21 18.3284 21 17.5V13.5C21 13.2239 21.2239 13 21.5 13C21.7761 13 22 13.2239 22 13.5V17.5C22 18.8807 20.8807 20 19.5 20H4.5C3.11929 20 2 18.8807 2 17.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSpacebar;
